import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Space,
  Table,
  Tooltip,
  Typography,
} from "antd";
import React, {
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { columnsTableMenu, optionsLieuDung } from "./PrescriptionTable.config";
import "./PrescriptionTable.scss";
import { technicalService, unitStoreService, storeService } from "api";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import { Notification } from "components/common";

const PrescriptionTable = React.forwardRef((props: any, ref) => {
  // redux
  let dispatch = useAppDispatch();

  const [dataSource, setDataSource] = useState<any>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    openModal: openModal,
    closeModal: closeModal,
    setData: setDataSource,
    getData: () => {
      return dataSource;
    },
    clearItem: (value) => {
      setDataSource([...dataSource.filter((it) => it.tenThuoc !== value)]);
    },
  }));
  const openModal = async () => {
    setIsModalOpen(true);
  };
  const closeModal = async () => {
    setIsModalOpen(false);
  };

  const handleSave = async () => {
    const allValues = dataSource.every((item) => item.tenThuoc);
    if (allValues) {
      await props.onSave();
      closeModal();
    }
  };
  // const fetchListTechnicalService = async params => {
  //   try {
  //     let response = await technicalService.getListTechnicalService(params);
  //     setDmDichVu(response);
  //   } catch (err) {}
  // };
  const [unitMedicine, setUnitMedicine] = useState<any>([]);
  const getUnit = async () => {
    try {
      const response = await unitStoreService.getUnit();
      setUnitMedicine(response.data.data);
    } catch {
      Notification("error", "Lấy danh sách đơn vị thuốc thất bại!");
    }
  };
  // const [props.thuocs, setThuocs] = useState<any>([]);
  // const fetchListThuocByParam = async (params) => {
  //   try {
  //     let response = await storeService.getListMedicineByParams(params);
  //     // console.log("🚀 ~ fetchListThuocByParam ~ response:", response)
  //     setThuocs(response);
  //   } catch (err) {
  //     // notification.error({message: "Lỗi khi lấy danh sách thuốc!"});
  //   }
  // };

  useEffect(() => {
    // fetchListThuocByParam({
    //   page: 1,
    //   limit: 9999,
    // });
    getUnit();
  }, []);

  const columns = columnsTableMenu.map((col) => {
    if (col.dataIndex === "idThuoc") {
      return {
        ...col,
        options: [
          ...props.thuocs.map((it) => ({
            value: it.id,
            label: it.id,
          })),
        ],
      };
    } else if (col.dataIndex === "tenThuoc") {
      return {
        ...col,
        options: [
          ...props.thuocs.map((it) => ({
            value: it.name,
            label: it.name,
          })),
        ],
      };
    } else if (col.dataIndex === "donVi") {
      return {
        ...col,
        options: [
          ...unitMedicine.map((unit) => {
            return {
              value: unit.name,
              label: unit.name,
            };
          }),
        ],
      };
    } else return col;
  });

  const [count, setCount] = useState(1);
  return (
    <div className="modal">
      <Modal
        wrapClassName="modal-custom"
        centered
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
        title={"Chọn dịch vụ bổ sung"}
        width={1080}
      >
        <div className="prescription-table-container">
          <Space direction="vertical" className="prescription-space">
            <Row gutter={[8, 8]}>
              <Col xs={24} md={24} sm={24} lg={24} xl={24}>
                <TableInputAdd
                  column={columns}
                  data={dataSource}
                  setData={setDataSource}
                  pagination={false}
                  // rowSelection={{
                  //   type: "checkbox",
                  //   onChange: onSelectRow,
                  //   selectedRowKeys: selectedRowKeys,
                  // }}
                  thuocs={props.thuocs}
                  count={count}
                  setCount={setCount}
                />
              </Col>
            </Row>
            <Row>
              <Row gutter={[0, 8]} justify={"end"} style={{ gap: "4px" }}>
                <Button type="primary" onClick={closeModal} danger>
                  Hủy
                </Button>
                <Button type="primary" onClick={handleSave}>
                  Lưu lại
                </Button>
              </Row>
            </Row>
          </Space>
        </div>
      </Modal>
    </div>
  );
});

export default PrescriptionTable;
